// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {
	mantineCssStyleRecordSchema,
	mantineStylesApiSchema,
} from "./primitives.zod";
import {mantineSizeTokenSchema} from "./spacing.zod";

export const mantineActionIconPropsSchema = z.object({
	color: z.string().optional(),
	variant: z.string().optional(),
	size: z.union([mantineSizeTokenSchema, z.number()]).optional(),
	style: mantineCssStyleRecordSchema.optional(),
	styles: mantineStylesApiSchema.optional(),
	loaderProps: z
		.object({
			type: z.string().optional(),
		})
		.optional(),
});
